// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as EditFlightActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import EditFlight from '../components/EditFlight';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    locale: state.locale.locale,
    isFetching: state.editFlight.isFetching,
    isPutting: state.editFlight.isPutting,
    flight: state.editFlight.flight,
    localValues: state.localValues,
    successUpdate: state.editFlight.successUpdate,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...EditFlightActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditFlight);



// WEBPACK FOOTER //
// ./src/modules/edit-flight/containers/EditFlightContainer.js